<template lang="pug">
  .simple-color-picker(v-click-outside="hideList")
    .picker-header(v-on:click="toggleList")
      span(v-if="label" class="label") {{label}}
      .color-value(v-bind:style="'background-color: ' + colorValue")
    transition(name="fade")
      .colors-list-container(v-show="show")
        .colors-list
          div(v-for="(color, i) in viewColors" v-on:click="hideList")
            label(v-bind:class="((colorValue == color) ? 'active' : '')" v-bind:for="'simple-color-input-'+id+'-'+i" v-bind:style="'background-color: ' + color")
            input(v-on:change="changeValue" v-bind:id="'simple-color-input-'+id+'-'+i" type="radio" v-bind:value="color" v-model="colorValue" name="color")
</template>
<script>
  import ClickOutside from 'vue-click-outside'
  export default {
    directives: {ClickOutside},
    name: 'simple-color-picker',
    props: ['colors', 'value', 'label'],
    data() {
      return {
        id: '',
        defaultColors: ['#2196f3', '#FF5252', '#FAFAFA', '#009688', '#000000', '#FFFFFF'],
        viewColors: [],
        colorValue: '',
        show: false
      }
    },
    watch: {
      '$props.colors'() {
        this.getColors();
      },
      '$props.value'(val) {
        this.colorValue = val;
      }
    },
    methods: {
      toggleList(e) {
        this.show = !this.show;
      },
      hideList() {
        this.show = false;
      },
      getColors() {
        if (!this.colors || !Object.keys(this.colors).length)
          this.viewColors = this.defaultColors;
        else
          this.viewColors = this.colors;

        if (!this.value) this.colorValue = this.viewColors[0];
        else this.colorValue = this.value;
      },
      changeValue() {
        this.$emit('input', this.colorValue);
        this.$emit('change', this.colorValue);
      }
    },
    created() {
      this.id = this._uid;
      this.$nextTick(() => {
        this.getColors();
      });
    }
  }
</script>
<style scoped lang="sass">
  .simple-color-picker
    display: table
    z-index: 100
    .picker-header
      display: flex
      align-items: center
      justify-content: flex-start
      flex-wrap: wrap
      cursor: default
      .label
        margin: 0 4px 4px 0
    .color-value
      display: block
      width: 35px
      height: 35px
      border-radius: 100%
      box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.75)
      margin: 0 4px 4px
    .colors-list-container
      display: table
      width: auto
      max-width: 184px
      .colors-list
        display: flex
        align-items: flex-start
        justify-content: flex-start
        flex-wrap: wrap
        position: absolute
        background-color: #fbfbfb
        border-radius: 4px
        border: 1px solid #a5a5a5
        z-index: 100
        label
          display: block
          width: 35px
          height: 35px
          border-radius: 100%
          box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.75)
          margin: 5px
        input
          display: none
</style>



// WEBPACK FOOTER //
// SimpleColorPicker.vue?4c512b7f